import React, { ReactNode } from 'react';
import ErrorBoundary from '@/components/ui/error-boundary';

interface ErrorBoundaryProviderProps {
  children: ReactNode;
}

/**
 * A provider component that wraps the entire application with an ErrorBoundary
 * Use this at the root level of your application or as high up as possible
 * to catch errors throughout your application.
 */
const ErrorBoundaryProvider: React.FC<ErrorBoundaryProviderProps> = ({ children }) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ErrorBoundaryProvider;
